import {
  type InfiniteData as InfiniteDataReact,
  type QueryKey,
  type UseInfiniteQueryOptions as UseInfiniteQueryOptionsReact,
  useInfiniteQuery as useInfiniteQueryReact,
} from '@tanstack/react-query';
import type { AxiosError } from 'axios';

type InfiniteData<TData, TPageParameter = unknown> = InfiniteDataReact<TData, TPageParameter>;

type UseInfiniteQueryOptions<
  TQueryFunctionData,
  TError,
  TData,
  TQueryKey extends QueryKey = QueryKey,
  TPageParameter = unknown,
> = UseInfiniteQueryOptionsReact<TQueryFunctionData, TError, TData, TQueryKey, TPageParameter>;

export const useInfiniteQuery = <
  TQueryFunctionData,
  TPageParameter = unknown,
  TError extends AxiosError = AxiosError,
  TData = InfiniteData<TQueryFunctionData>,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseInfiniteQueryOptions<TQueryFunctionData, TError, TData, TQueryKey, TPageParameter>,
) =>
  useInfiniteQueryReact<TQueryFunctionData, TError, TData, TQueryKey, TPageParameter>({
    gcTime: 5 * 60 * 1000, // 5 Minutes
    // They need to be same,
    // otherwise there is really bad issue that it will fetch all previous loaded pages and refetch 1 by 1
    // and you would expect it will fetch only first page when fetching staled data
    staleTime: 5 * 60 * 1000, // 5 Minutes
    throwOnError: true,
    ...options,
  });
